//local import
import { TenantModel } from '@core/data';

export class TenantSwitchSelectionRequestedMessage {
  public tenant: TenantModel;

  constructor(tenant: TenantModel) {
    this.tenant = tenant;
  }
}
